<header mat-dialog-title class="dialog-header">
    <h3 mat-dialog-title class="mat-h2">Compartir en Classroom</h3>
    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</header>
<mat-dialog-content>
    <mat-horizontal-stepper [linear]="true" #stepperDialog>
        <mat-step label="Genere la hoja de cálculo con la rúbrica" [completed]="false" #step>
            <div class="flex-wrap">
                <button mat-raised-button color="primary" (click)="crearSpreadsheet(stepperDialog)"
                    [disabled]="data.datos.length == 0">Crear hoja de cálculo</button>
                <span class="spacer"></span>
            </div>
            <br>
            <mat-progress-bar *ngIf="cargandoSpreadsheet" mode="indeterminate">
            </mat-progress-bar>
        </mat-step>
        <mat-step #step2>
            <ng-template matStepLabel>Comparta la rúbrica en una de
                <br>sus clases de Google Classroom
            </ng-template>
            <div class="flex-wrap" style="align-items: center;">
                <div id="widget-div-dialog" style="margin-right: 16px;"></div>
                <div style="margin-left: 16px;">Enviar a Classroom</div>
            </div>
        </mat-step>
    </mat-horizontal-stepper>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Cerrar</button>
</mat-dialog-actions>